import { Element } from '../../../../../common/html/element'
import { formatText } from '../../../../../helpers/value'
import { UseScoreRange } from '../../../../score/common/hooks/useScoreRange'
import classes from '../../index.module.scss'

const PerformanceCell = ({ val }) => {
  const { perRange } = UseScoreRange(true, val)
  const backgroundColor = perRange ? perRange.color : '#9C9C9C'

  return (
    <div className="dFlex justifyContentCenter">
      <Element className={classes.scoreItem} style={{ backgroundColor }}>
        <span className="fw600">{formatText(val)}</span>
      </Element>
    </div>
  )
}

export default PerformanceCell
